module.exports = __webpack_public_path__ + "img/happybrain_info4.81349847.jpg";